import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { landAfterSignIn } from '../services/oauthRelay';
import './AuthPages.css';

/* This page is the redirect URI registered with Google, and it is always served
 * from the canonical frontend — a company advisor subdomain cannot be a
 * registered callback, so the relay points every consent request here whatever
 * host it started on. `window.location.origin` is therefore the registered
 * origin, and matches the redirect_uri the backend sent to Google. */
const GOOGLE_REDIRECT_URI = `${window.location.origin}/auth/google/callback`;

export default function GoogleCallback() {
  const { googleCodeSignIn } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      setError('No authorization code received from Google.');
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        // `state` goes to the server unread: it names the host that started
        // this, and only the server can tell a blob we signed from one we
        // did not.
        const data = await googleCodeSignIn(
          code, GOOGLE_REDIRECT_URI, searchParams.get('state') || '');
        if (cancelled) return;
        landAfterSignIn(data.return_to, navigate, '/');
      } catch (err) {
        if (cancelled) return;
        setError(err.response?.data?.detail || 'Google sign-in failed. Please try again.');
      }
    })();

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-logo">AI Broker</div>
          <h1>Sign-in failed</h1>
          <div className="auth-error">{error}</div>
          <button className="auth-btn primary" onClick={() => navigate('/login', { replace: true })}>
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <div className="auth-logo">AI Broker</div>
        <h1>Signing you in…</h1>
        <p className="auth-subtitle">Please wait while we complete your Google sign-in.</p>
      </div>
    </div>
  );
}
